import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, toRefs } from "vue";
import CustomModal from "../common/CustomModal.vue";
import { CommunityTalkImage, CommunityTalkMovie } from "@/apiRequests/models/communityTalk/talkRoomGetResponse";

interface Props {
	/**
	 * 画像情報。
	 */
	images: CommunityTalkImage[];
	/**
	 * 動画情報。
	 */
	movies: CommunityTalkMovie[];
}
interface State {
	/**
	 * モーダル表示対象のコンテンツ。
	 */
	modalMediaUrl: string | null;
	/**
	 * メディアの種別。
	 */
	modalMediaType: "image" | "movie";
}
// reactiveな変数宣言

export default /*#__PURE__*/_defineComponent({
  props: {
    images: { type: Array, required: true },
    movies: { type: Array, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

/**
 * トークルーム・リプライ > 画像・動画表示。
 */



const state = reactive<State>({
	modalMediaUrl: null,
	modalMediaType: "image",
});
const { modalMediaUrl, modalMediaType } = toRefs(state);

const modalComponent = ref<InstanceType<typeof CustomModal> | null>(null);
const openModal = (url: string, type: "image" | "movie"): void => {
	state.modalMediaUrl = url;
	state.modalMediaType = type;
	modalComponent.value?.openModal();
};

const __returned__ = { state, modalMediaUrl, modalMediaType, modalComponent, openModal, CustomModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})